import clsx from 'clsx';
import { ReactNode } from 'react';

interface Props {
  content: ReactNode;
  className?: string;
}

function Header(props: Props) {
  const { className = '', content } = props;

  return (
    <div className={clsx('FusePageSimple-header', className)}>
      <div className="container">{content}</div>
    </div>
  );
}

export default Header;
